import { IconButton, InputBase, Paper } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import Avatar from '../../../../base/avatar/components/Avatar';
import { hideDialog } from '../../../../base/dialog/actions';
import { translate } from '../../../../base/i18n/functions';
import Icon from '../../../../base/icons/components/Icon';
import { IconEnvelope, IconMinusPrimary, IconPhoneRinging, IconPlusPrimary, IconUser } from '../../../../base/icons/svg';
import Button from '../../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../../base/ui/constants.any';
import { isVpaasMeeting } from '../../../../jaas/functions';
import { countConfigSip, enableSipCallIn } from '../../../../videosipgw/actions';
import { INVITE_TYPES } from '../../../constants';
import AbstractAddPeopleDialog, { _mapStateToProps as _abstractMapStateToProps } from '../AbstractAddPeopleDialog';
import { getFunctions, getFunctionValueInFunction } from '../../../../user/functions';
import { USER_FUNCTIONS } from '../../../../user/constant';
const styles = (theme) => {
    return {
        formWrap: {
            marginTop: '16px'
        },
        inviteButtons: {
            display: 'flex',
            justifyContent: 'end',
            // marginTop: '16px',
            padding: '24px 0px',
            '& .invite-button': {
                marginLeft: theme.spacing(2)
            }
        },
        numberGroup: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '16px'
        },
        numberForm: {
            borderRadius: '6px',
            border: `1px solid ${theme.palette?.outline}`,
            boxShadow: 'none',
            overflow: 'hidden',
            height: '34px',
            width: '116px',
            // '&:hover': {
            //     borderColor: theme.palette?.borderHover
            // },
            '&:has(.Mui-focused)': {
                borderColor: theme.palette?.borderHover,
                // borderWidth: '2px',
                // height: '32px',
                // width: '114px',
            },
            '& .MuiInputBase-input': {
                textAlign: 'center !important'
            }
        },
        inputNumber: {
            borderLeft: `1px solid ${theme.palette?.outline}`,
            borderRight: `1px solid ${theme.palette?.outline}`,
            height: '100%',
            '&.Mui-focused': {
                borderColor: theme.palette?.borderHover,
            },
        },
        numberButtonGroup: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
            // backgroundColor: theme.palette?.primary12
        },
        numberButton: {
            color: theme.palette?.outline,
            fontWeight: 'bold',
            padding: '0px',
            paddingLeft: '10px',
            paddingRight: '10px',
            borderRadius: '0px',
            width: '34px',
            height: '100% !important'
        }
    };
};
/**
 * Form that enables inviting others to the call.
 */
class InviteContactsForm extends AbstractAddPeopleDialog {
    /**
     * Initializes a new {@code AddPeopleDialog} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._multiselect = null;
        this.state = {
            addToCallError: false,
            addToCallInProgress: false,
            inviteItems: [],
            textSip: '',
            sipNumber: Math.min((this.props.totalNumberIn || 0) + 1, parseInt(getFunctionValueInFunction(this.props.functions, USER_FUNCTIONS.SIP_CONNECTION, 1))),
        };
        // Bind event handlers so they are only bound once per instance.
        this._onClearItems = this._onClearItems.bind(this);
        this._onClearItemsKeyPress = this._onClearItemsKeyPress.bind(this);
        this._onItemSelected = this._onItemSelected.bind(this);
        this._onSelectionChange = this._onSelectionChange.bind(this);
        this._onSubmitListenKeyPress = this._onSubmitListenKeyPress.bind(this);
        this._onListen = this._onListen.bind(this);
        this._parseQueryResults = this._parseQueryResults.bind(this);
        this._setMultiSelectElement = this._setMultiSelectElement.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onNumberSipChange = this._onNumberSipChange.bind(this);
        this._onNumberSipIncrease = this._onNumberSipIncrease.bind(this);
        this._onNumberSipDecrease = this._onNumberSipDecrease.bind(this);
        this._isAddDisabled = this._isAddDisabled.bind(this);
        this._resourceClient = {
            makeQuery: this._query,
            parseResults: this._parseQueryResults
        };
        const { t } = props;
        this._translations = {
            _dialOutEnabled: t('addPeople.phoneNumbers'),
            _addPeopleEnabled: t('addPeople.contacts'),
            _sipInviteEnabled: t('addPeople.sipAddresses')
        };
    }
    /**
     * React Component method that executes once component is updated.
     *
     * @param {Props} prevProps - The props object before the update.
     * @param {State} prevState - The state object before the update.
     * @returns {void}
     */
    componentDidUpdate(prevProps, prevState) {
        /**
         * Clears selected items from the multi select component on successful
         * invite.
         */
        if (prevState.addToCallError
            && !this.state.addToCallInProgress
            && !this.state.addToCallError
            && this._multiselect) {
            this._multiselect.setSelectedItems([]);
        }
    }
    /**
     * Renders the content of this component.
     *
     * @returns {ReactElement}
     */
    render() {
        const { _addPeopleEnabled, _dialOutEnabled, _sipInviteEnabled, t } = this.props;
        const classes = withStyles.getClasses(this.props);
        const features = {
            _dialOutEnabled,
            _addPeopleEnabled,
            _sipInviteEnabled
        };
        const computedPlaceholder = Object.keys(features)
            .filter(v => Boolean(features[v]))
            .map(v => this._translations[v])
            .join(', ');
        return (React.createElement("div", { onKeyDown: this._onKeyDown },
            React.createElement("div", null,
                React.createElement("div", { className: classes.numberGroup },
                    React.createElement("span", { style: { fontSize: "16px" } },
                        t('addPeople.listenNumber'),
                        React.createElement("span", { style: { color: "#EE0033" } }, " *")),
                    React.createElement(Paper, { className: classes.numberForm, component: "form", sx: { display: 'flex', alignItems: 'center' } },
                        React.createElement("div", { className: classes.numberButtonGroup },
                            React.createElement(IconButton, { className: classes.numberButton, size: 'small', onClick: this._onNumberSipDecrease },
                                React.createElement(Icon, { src: IconMinusPrimary, size: 14 }))),
                        React.createElement(InputBase, { className: classes.inputNumber, sx: { flex: 1, textAlign: 'center' }, placeholder: t('addPeople.sipAddressPlaceholder'), type: 'tel', onChange: this._onNumberSipChange, value: this.state.sipNumber }),
                        React.createElement("div", { className: classes.numberButtonGroup },
                            React.createElement(IconButton, { className: classes.numberButton, size: 'small', onClick: this._onNumberSipIncrease },
                                React.createElement(Icon, { src: IconPlusPrimary, size: 14 }))))),
                React.createElement("div", { style: { marginTop: '16px' } },
                    React.createElement("span", { style: { fontSize: "16px" } }, `${t('addPeople.allowListenNumber')}: `),
                    React.createElement("span", { style: { fontSize: "16px", fontWeight: 'bold' } }, (parseInt(getFunctionValueInFunction(this.props.functions, USER_FUNCTIONS.SIP_CONNECTION, 1))) - (this.props.totalSipInstance || 0))),
                React.createElement("div", { className: classes.inviteButtons },
                    React.createElement(Button, { "aria-label": t('addPeople.cancel'), className: 'invite-button', label: t('addPeople.cancel'), onClick: () => {
                            APP.store.dispatch(hideDialog());
                        }, role: 'button', type: BUTTON_TYPES.SECONDARY, size: "mediumSmall" }),
                    React.createElement(Button, { "aria-label": t('addPeople.listen'), className: 'invite-button', disabled: this._isAddDisabled(), label: t('addPeople.listen'), onClick: this._onListen, onKeyPress: this._onSubmitListenKeyPress, role: 'button', size: "mediumSmall" })))));
    }
    _onNumberSipChange({ target: { value } }) {
        const number = Number.parseInt(value);
        if (number >= 0) {
            this.setState({
                sipNumber: number
            });
        }
    }
    _onNumberSipIncrease() {
        this.setState((state) => ({
            ...state,
            sipNumber: (state.sipNumber || 0) + 1
        }));
    }
    _onNumberSipDecrease() {
        this.setState((state) => ({
            ...state,
            sipNumber: Math.max((state.sipNumber || 0) - 1, (this.props.totalNumberIn || 0))
        }));
    }
    _isAddDisabled() {
        return (this.state.sipNumber - (this.props.totalNumberIn || 0)) < 1
            || (this.state.sipNumber - (this.props.totalNumberIn || 0)) > (parseInt(getFunctionValueInFunction(this.props.functions, USER_FUNCTIONS.SIP_CONNECTION, 1))) - (this.props.totalSipInstance || 0);
        // return this.state.sipNumber < ((this.props.totalNumberIn || 0) + 1)
    }
    ;
    /**
     * Callback invoked when a selection has been made but before it has been
     * set as selected.
     *
     * @param {IInviteSelectItem} item - The item that has just been selected.
     * @private
     * @returns {Object} The item to display as selected in the input.
     */
    _onItemSelected(item) {
        if (item.item.type === INVITE_TYPES.PHONE) {
            item.content = item.item.number;
        }
        return item;
    }
    /**
     * Handles a selection change.
     *
     * @param {Array<IInviteSelectItem>} selectedItems - The list of selected items.
     * @private
     * @returns {void}
     */
    _onSelectionChange(selectedItems) {
        this.setState({
            inviteItems: selectedItems
        });
    }
    _onListen() {
        const { token, sipId, conference, totalNumberIn } = this.props;
        if (token && conference && !this._isAddDisabled()) {
            this.props.dispatch(countConfigSip(this.state.sipNumber));
            this.props.dispatch(enableSipCallIn(token, sipId || '', conference, Math.max(0, this.state.sipNumber - (totalNumberIn || 0))));
            APP.store.dispatch(hideDialog());
        }
    }
    /**
     * KeyPress handler for accessibility.
     *
     * @param {KeyboardEvent} e - The key event to handle.
     *
     * @returns {void}
     */
    _onSubmitListenKeyPress(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            this._onListen();
        }
        else if (e.key === "Esc") {
            APP.store.dispatch(hideDialog());
        }
    }
    /**
     * Handles 'Enter' key in the form to trigger the invite.
     *
     * @param {KeyboardEvent} event - The key event.
     * @returns {void}
     */
    _onKeyDown(event) {
        const { inviteItems } = this.state;
        if (event.key === 'Enter') {
            event.preventDefault();
            if (!this._isAddDisabled() && inviteItems.length) {
                this._onListen();
            }
        }
    }
    /**
     * Returns the avatar component for a user.
     *
     * @param {any} user - The user.
     * @param {string} className - The CSS class for the avatar component.
     * @private
     * @returns {ReactElement}
     */
    _getAvatar(user, className = 'avatar-small') {
        const defaultIcon = user.type === INVITE_TYPES.EMAIL ? IconEnvelope : IconUser;
        return (React.createElement(Avatar, { className: className, defaultIcon: defaultIcon, size: 32, status: user.status, url: user.avatar }));
    }
    /**
     * Processes results from requesting available numbers and people by munging
     * each result into a format {@code MultiSelectAutocomplete} can use for
     * display.
     *
     * @param {Array} response - The response object from the server for the
     * query.
     * @private
     * @returns {Object[]} Configuration objects for items to display in the
     * search autocomplete.
     */
    _parseQueryResults(response = []) {
        const { t, _dialOutEnabled } = this.props;
        const userTypes = [INVITE_TYPES.USER, INVITE_TYPES.EMAIL, INVITE_TYPES.VIDEO_ROOM, INVITE_TYPES.ROOM];
        const users = response.filter(item => userTypes.includes(item.type));
        const userDisplayItems = [];
        for (const user of users) {
            const { name, phone } = user;
            const tagAvatar = this._getAvatar(user, 'avatar-xsmall');
            const elemAvatar = this._getAvatar(user);
            userDisplayItems.push({
                content: name,
                elemBefore: elemAvatar,
                item: user,
                tag: {
                    elemBefore: tagAvatar
                },
                value: user.id || user.user_id
            });
            if (phone && _dialOutEnabled) {
                userDisplayItems.push({
                    filterValues: [name, phone],
                    content: `${phone} (${name})`,
                    elemBefore: elemAvatar,
                    item: {
                        type: INVITE_TYPES.PHONE,
                        number: phone
                    },
                    tag: {
                        elemBefore: tagAvatar
                    },
                    value: phone
                });
            }
        }
        const numbers = response.filter(item => item.type === INVITE_TYPES.PHONE);
        const telephoneIcon = this._renderTelephoneIcon();
        const numberDisplayItems = numbers.map(number => {
            const numberNotAllowedMessage = number.allowed ? '' : t('addPeople.countryNotSupported');
            const countryCodeReminder = number.showCountryCodeReminder
                ? t('addPeople.countryReminder') : '';
            const description = `${numberNotAllowedMessage} ${countryCodeReminder}`.trim();
            return {
                filterValues: [
                    number.originalEntry,
                    number.number
                ],
                content: t('addPeople.telephone', { number: number.number }),
                description,
                isDisabled: !number.allowed,
                elemBefore: telephoneIcon,
                item: number,
                tag: {
                    elemBefore: telephoneIcon
                },
                value: number.number
            };
        });
        const sipAddresses = response.filter(item => item.type === INVITE_TYPES.SIP);
        const sipDisplayItems = sipAddresses.map(sip => {
            return {
                filterValues: [
                    sip.address
                ],
                content: sip.address,
                description: '',
                item: sip,
                value: sip.address
            };
        });
        return [
            ...userDisplayItems,
            ...numberDisplayItems,
            ...sipDisplayItems
        ];
    }
    /**
     * Clears the selected items from state and form.
     *
     * @returns {void}
     */
    _onClearItems() {
        if (this._multiselect) {
            this._multiselect.setSelectedItems([]);
        }
        this.setState({ inviteItems: [] });
    }
    /**
     * Clears the selected items from state and form.
     *
     * @param {KeyboardEvent} e - The key event to handle.
     *
     * @returns {void}
     */
    _onClearItemsKeyPress(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            this._onClearItems();
        }
    }
    /**
     * Renders a telephone icon.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderTelephoneIcon() {
        return (React.createElement(Icon, { src: IconPhoneRinging }));
    }
    /**
     * Sets the instance variable for the multi select component
     * element so it can be accessed directly.
     *
     * @param {MultiSelectAutocomplete} element - The DOM element for the component's dialog.
     * @private
     * @returns {void}
     */
    _setMultiSelectElement(element) {
        this._multiselect = element;
    }
}
/**
 * Maps (parts of) the Redux state to the associated
 * {@code AddPeopleDialog}'s props.
 *
 * @param {IReduxState} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const { sipId, token, sessionsMap, totalNumberIn, totalSipInstance } = state['features/videosipgw'];
    const { conference } = state['features/base/conference'];
    const functions = getFunctions(state);
    return {
        ..._abstractMapStateToProps(state),
        sipId,
        token,
        sessionsMap,
        totalNumberIn,
        conference,
        _isVpaas: isVpaasMeeting(state),
        functions,
        totalSipInstance
    };
}
// @ts-expect-error
export default translate(connect(_mapStateToProps)(withStyles(InviteContactsForm, styles)));
